import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { GravityQualifier } from "../GravityQualifier";
/**
 * @description The class for the autoGravity builder
 * @memberOf Qualifiers.Gravity
 * @extends {Qualifiers.Gravity.GravityQualifier}
 */

var AutoGravity = /*#__PURE__*/function (_GravityQualifier) {
  _inherits(AutoGravity, _GravityQualifier);

  var _super = _createSuper(AutoGravity);

  function AutoGravity() {
    _classCallCheck(this, AutoGravity);

    // Required due to https://github.com/microsoft/TypeScript/issues/13029

    /* istanbul ignore next */
    return _super.call(this, 'auto');
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */


  _createClass(AutoGravity, [{
    key: "autoFocus",
    value: function autoFocus() {
      for (var _len = arguments.length, AutoFocusObjects = new Array(_len), _key = 0; _key < _len; _key++) {
        AutoFocusObjects[_key] = arguments[_key];
      }

      this.addValue(AutoFocusObjects);
      return this;
    }
  }]);

  return AutoGravity;
}(GravityQualifier);

export { AutoGravity };